export default __webpack_public_path__ + "static/media/message.d6392fe0.svg";